import { Logo } from 'assets/images'
import { Link } from 'react-router-dom'
import { routes } from 'utils/routes'

const Error404 = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-4">
      {/* Logo Section */}

      {/* Card Section */}
      <div className="rounded-mb-0 w-full max-w-md rounded-md bg-white text-center shadow-md">
        <Link
          to="/"
          className="mt-0 flex h-[100px] items-center justify-center rounded-md bg-purple-900 p-3"
        >
          <img src={Logo} alt="Logo" className="h-12 object-contain" />
        </Link>
        <div className="p-4">
          <h1 className="mb-2 text-5xl font-extrabold text-purple-800">404</h1>
          <h2 className="mb-2 text-xl font-bold text-gray-800">
            <span className="text-red-600">Oops!</span>{' '}
            <span className="text-gray-700">Page not found.</span>
          </h2>
          <p className="mb-4 text-gray-500">
            The page you’re looking for doesn’t exist or has been moved.
          </p>
          <Link
            to={routes.dashboard}
            className="rounded-md bg-purple-900 px-5 py-2 text-white transition hover:bg-purple-950"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Error404
